<template>
	<div class="c-zn-forms__sort">
		<span>Sorteren op:</span>
		<div class="c-zn-forms__sortbtns">
			<div class="c-zn-forms__sortbtn">
				<input type="radio" v-model="value" id="name" value="name" />
				<label for="name">Naam</label>
			</div>
			<div class="c-zn-forms__sortbtn">
				<input type="radio" v-model="value" id="date" value="date" />
				<label for="date">Datum</label>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		modelValue: {},
	},
	data() {
		return {
			value: this.modelValue,
		};
	},
	watch: {
        modelValue() {
            this.value = this.modelValue;
        },
		value() {
			this.$emit('update:modelValue', this.value);
		},
	},
};
</script>
